import { EgretLoadable } from "egret";


const adminManagment = EgretLoadable({
  loader: () => import("./AdminManagment")
});

const adminBlock = EgretLoadable({
  loader: () => import("./AdminBlock")
});

const adminManagmentRoutes = [
  {
    path: "/agentManagement",
    component: adminManagment
    },
    {
        path: "/adminblock",
        component: adminBlock
    }
];
 
export default adminManagmentRoutes;
